export enum UserType {
  ADMIN = 'Dentsu',
  GOVERNMENT = 'Government',
  INDUSTRY = 'Industry'
}